/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { opportunitySchema } from './opportunity-schema';
import { userSchema } from './user-schema';
import { CandidateStatus } from "../enums";

export const candidatesOpportunitiesStatusHistorySchema: z.AnyZodObject = z.object({
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  candidateStatus: z.nativeEnum(CandidateStatus).nullish(),
  candidateStatusUpdatedAt: z.string().datetime().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  previousCandidateStatus: z.string().nullish(),
  previousPositiveCandidateStatus: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
  updatedBy: z.string().uuid().nullish(),
  updatedByUser: z.lazy(() => userSchema).nullish(),
});

export type CandidatesOpportunitiesStatusHistory = z.infer<typeof candidatesOpportunitiesStatusHistorySchema>;
